var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-layout-loading"},[_c('v-spinner',{staticClass:"spinner",attrs:{"line-fg-color":"var(--blue-grey-300)","line-bg-color":"var(--blue-grey-200)"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }